module.exports = __webpack_public_path__ + "img/main.a372d0b8.png";